import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots, faTimes, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const SupportInteractiveToast = ({ toast, onOpenTicket, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (toast) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => onDismiss(), 300);
      }, 7000);
      return () => clearTimeout(timer);
    }
  }, [toast, onDismiss]);

  if (!toast) return null;

  const handleOpen = () => {
    setIsVisible(false);
    setTimeout(() => {
      onOpenTicket(toast.idTicket);
      onDismiss();
    }, 150);
  };

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => onDismiss(), 250);
  };

  return (
    <div
      className="position-fixed bottom-0 end-0 m-3 m-md-4"
      style={{
        zIndex: 99999,
        maxWidth: '380px',
        width: 'calc(100vw - 32px)',
        transform: isVisible ? 'translateY(0)' : 'translateY(25px)',
        opacity: isVisible ? 1 : 0,
        transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
      }}
    >
      <div
        className="card border-0 shadow-lg"
        style={{
          borderRadius: '12px',
          overflow: 'hidden',
          borderLeft: '5px solid #25d366',
          boxShadow: '0 12px 36px rgba(0, 0, 0, 0.16), 0 2px 8px rgba(37, 211, 102, 0.2)'
        }}
      >
        <div className="card-body p-3">
          {/* Header */}
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center text-white"
                style={{
                  width: '26px',
                  height: '26px',
                  backgroundColor: '#25d366',
                  fontSize: '0.85rem'
                }}
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </div>
              <span className="fw-bold text-dark font-sans-serif" style={{ fontSize: '0.88rem' }}>
                Ticket #{toast.idTicket}
              </span>
              <span className="badge bg-soft-success text-success rounded-pill px-2 py-0" style={{ fontSize: '0.7rem' }}>
                Nuevo mensaje
              </span>
            </div>
            <button
              type="button"
              className="btn btn-sm btn-link text-400 p-0 text-decoration-none hover-text-dark"
              onClick={handleClose}
              title="Cerrar notificación"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          {/* Cliente y mensaje */}
          <div className="mb-2">
            <div className="fw-semibold text-900 text-truncate" style={{ fontSize: '0.85rem' }}>
              {toast.customerName || 'Cliente'}
            </div>
            <div
              className="text-secondary small text-truncate-2"
              style={{
                fontSize: '0.8rem',
                lineHeight: '1.3',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
              }}
            >
              {toast.messageText || 'Ha enviado un nuevo mensaje'}
            </div>
          </div>

          {/* Acciones */}
          <div className="d-flex align-items-center justify-content-end gap-2 pt-1">
            <button
              type="button"
              className="btn btn-sm btn-link text-muted text-decoration-none px-2 py-1"
              style={{ fontSize: '0.78rem' }}
              onClick={handleClose}
            >
              Ignorar
            </button>
            <button
              type="button"
              className="btn btn-sm btn-success px-3 py-1 d-flex align-items-center gap-1 shadow-sm"
              style={{
                backgroundColor: '#25d366',
                borderColor: '#25d366',
                fontSize: '0.78rem',
                fontWeight: 600
              }}
              onClick={handleOpen}
            >
              <span>Ver conversación</span>
              <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: '0.72rem' }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportInteractiveToast;
